const userCache = {};

export const getCachedUser = (username) => {
  return userCache[username] || null;
};

export const setCachedUser = (username, data) => {
  userCache[username] = data;
};

export const getManyCachedUsers = (usernames) => {
  return usernames.map(u => ({
    username: u,
    ...userCache[u]
  }));
};